import $ from 'jquery';
import { Notice, noticeManager } from './notice';

$(document).ready(() => {
  const wishlistNotice = new Notice();
  const wishlistNoticeManager = (method, args) => noticeManager(wishlistNotice, method, args);

  /**
   * JS logic for article wishlist
   *
   * @param  {Node} scope the scope in which to search for articles to reload
   * @return {void}
   */
  function updateItemAmount(scope = document) {
    // change article count on wishlist
    $(scope).find('.js-changeamount-noticelist').on('click', (event) => {
      const element = event.target;
      const wishlistForm = element.closest('form');
      const countInput = wishlistForm.querySelector('input[name=am]');
      const xhr = new XMLHttpRequest();
      const formData = new FormData(wishlistForm);

      xhr.open(wishlistForm.method, wishlistForm.action, true);
      xhr.onload = () => {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.response);

          if (response.return === -1) {
            // show error message
            wishlistNoticeManager('setMessage', [response.message]);
            wishlistNoticeManager('setType', ['error']);
            wishlistNoticeManager('render');
            wishlistNoticeManager('displayNoticeAtElementPosition', [countInput]);

            // Amount could not be changed.
            // Reset to previous value (we only do this in the noticelist)
            countInput.value = response.amount;
          } else if (response.return === 1) {
            element.classList.add('is--disabled');
            if (response.amount <= 0) {
              // article removed from list
              location.reload();
            } else {
              if (response.total) {
                $(wishlistForm).parent()
                  .parent()
                  .parent()
                  .find('.linesum')
                  .html(response.total);
              }

              // show success message
              wishlistNoticeManager('setMessage', [response.message]);
              wishlistNoticeManager('setType', ['success']);
              wishlistNoticeManager('render');
              wishlistNoticeManager('displayNoticeAtElementPosition', [countInput]);
            }
          }
        }
      };
      xhr.send(formData);
    });
  }

  $(document).find('.js-wishlistform').submit((e) => {
    e.preventDefault();
  });

  updateItemAmount();
});



// WEBPACK FOOTER //
// ./assets/js/components/wishlist.js